"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.clientAccountsReducerFunction = exports.clientAccountsActions = exports.ClientAccountsState = exports.initialState = void 0;
var immer_reducer_1 = require("immer-reducer");
var ClientFamily_1 = __importDefault(require("../models/ClientFamily"));
var EligibilityCoachConso_1 = require("../models/EligibilityCoachConso");
exports.initialState = {
    clientAccounts: null,
    clientFamilies: null,
    isClientEligible: false,
    selectedClientFamily: null,
    isFamilyMode: false,
    errorMessage: null,
    loading: false,
    success: false,
    selectedSectionSubscripiton: null,
    selectedCustomerAccount: null,
    selectedClientAccount: null,
    addContractLoading: false,
    addContractSuccess: false,
    addContractErrorMsg: null,
    updateContractName: {
        loading: false,
        errorMessage: null,
        status: 'none',
        success: null
    },
    removeContract: {
        removeContractLoading: false,
        removeContractErrorMsg: null,
        removeContractSuccess: null,
        removeContractStatus: 'none'
    },
    deleteFamily: {
        loading: false,
        errorMessage: null,
        success: null
    },
    createFamily: {
        loading: false,
        errorMessage: null,
        success: null
    },
    updateFamily: {
        loading: false,
        errorMessage: null,
        success: null
    },
    renameSectionSubscription: {
        loading: false,
        errorMessage: null,
        success: null
    },
    eligibilityCoachConso: {
        loading: false,
        success: false,
        errorMessage: null,
        data: {
            isError404: false,
            code: EligibilityCoachConso_1.NotEligibleErrorCodeEnum.NO_ERROR,
            message: "",
            water: null
        }
    }
};
var ClientAccountsState = /** @class */ (function (_super) {
    __extends(ClientAccountsState, _super);
    function ClientAccountsState() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    ClientAccountsState.prototype.getClientAccountsData = function (clientInfos) {
        this.draftState.loading = true;
        this.draftState.errorMessage = null;
        this.draftState.success = false;
        this.draftState.clientAccounts = null;
    };
    ClientAccountsState.prototype.getClientAccountsFailure = function (errorMessage) {
        this.draftState.loading = false;
        this.draftState.errorMessage = errorMessage;
        this.draftState.clientAccounts = null;
        this.draftState.success = false;
    };
    /**
     * Action Pour mettre à jour le state suite au succès de l'appel back getClientAccountsData
     * @param {Array<ClientAccount>} clients liste contenant la réponse du service pour récupérer les comptes clients
     * @param {string=} clientId Id du compte client utilisé pour mettre à jour le selectedClientAccount
     * @param {string=} customerAccountId Id du compte client utilisé pour mettre à jour le selectedCustomerAccount
     * @param {string=} sectionSubscriptionId Id du compte client utilisé pour mettre à jour le selectedSectionSubscripiton
     * @param {boolean} isClientEligible retourné par le back indique si le client est eligible à avoir un compte pro
     * @param {Array<ClientFamily>} clientFamilies liste contenant les familles récupérer par le service pde récupération des comptes clients
     * Permet à l'utilisateur de sélectionner une des familles qu'il a créé
     **/
    ClientAccountsState.prototype.getClientAccountsSuccess = function (clients, clientId, customerAccountId, sectionSubscriptionId, clientFamilies, isClientEligible, familyId) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        if (isClientEligible === void 0) { isClientEligible = false; }
        this.draftState.loading = false;
        this.draftState.success = true;
        this.draftState.errorMessage = null;
        this.draftState.clientAccounts = clients;
        this.draftState.selectedClientAccount = clientId
            ? ((_a = this.draftState.clientAccounts) === null || _a === void 0 ? void 0 : _a.find(function (client) { return client.clientId === clientId; })) || this.draftState.clientAccounts[0]
            : this.draftState.clientAccounts[0];
        this.draftState.selectedCustomerAccount = customerAccountId
            ? ((_c = (_b = this.draftState.selectedClientAccount) === null || _b === void 0 ? void 0 : _b.customerAccounts) === null || _c === void 0 ? void 0 : _c.find(function (acc) {
                return acc.customerAccountId === customerAccountId;
            })) || ((_d = this.draftState.selectedClientAccount) === null || _d === void 0 ? void 0 : _d.customerAccounts[0])
            : (_e = this.draftState.selectedClientAccount) === null || _e === void 0 ? void 0 : _e.customerAccounts[0];
        this.draftState.selectedSectionSubscripiton = sectionSubscriptionId
            ? ((_g = (_f = this.draftState.selectedCustomerAccount) === null || _f === void 0 ? void 0 : _f.sectionSubscriptions) === null || _g === void 0 ? void 0 : _g.find(function (section) {
                return section.sectionSubscriptionId === sectionSubscriptionId;
            })) ||
                ((_h = this.draftState.selectedCustomerAccount) === null || _h === void 0 ? void 0 : _h.sectionSubscriptions[0])
            : (_j = this.draftState.selectedCustomerAccount) === null || _j === void 0 ? void 0 : _j.sectionSubscriptions[0];
        this.draftState.isClientEligible = isClientEligible;
        this.draftState.isFamilyMode = false;
        if (isClientEligible && clientFamilies && clientFamilies.length) {
            this.draftState.clientFamilies = clientFamilies;
            this.draftState.selectedClientFamily = familyId
                ? ((_k = this.draftState.clientFamilies) === null || _k === void 0 ? void 0 : _k.find(function (family) {
                    return family.familyId.toString() === familyId;
                })) || clientFamilies[0]
                : clientFamilies[0];
        }
    };
    ClientAccountsState.prototype.setSelectedClientAccount = function (clientId) {
        var _a;
        this.draftState.selectedClientAccount =
            ((_a = this.draftState.clientAccounts) === null || _a === void 0 ? void 0 : _a.find(function (client) { return client.clientId === clientId; })) || null;
        this.draftState.isFamilyMode = false;
    };
    ClientAccountsState.prototype.setSelectedCustomerAccount = function (customerAccountId) {
        var _a, _b;
        this.draftState.selectedCustomerAccount =
            ((_b = (_a = this.draftState.selectedClientAccount) === null || _a === void 0 ? void 0 : _a.customerAccounts) === null || _b === void 0 ? void 0 : _b.find(function (acc) {
                return acc.customerAccountId === customerAccountId;
            })) || null;
        this.draftState.isFamilyMode = false;
    };
    ClientAccountsState.prototype.setSelectedSectionSubscription = function (sectionSubscriptionId) {
        var _a, _b;
        this.draftState.selectedSectionSubscripiton =
            ((_b = (_a = this.draftState.selectedCustomerAccount) === null || _a === void 0 ? void 0 : _a.sectionSubscriptions) === null || _b === void 0 ? void 0 : _b.find(function (section) {
                return section.sectionSubscriptionId === sectionSubscriptionId;
            })) || null;
    };
    /**
     * Action Pour la gestion des familles pour un utilisateur eligible
     * @param {number} familyId l'id de la famille sélectionée
     * Permet à l'utilisateur de sélectionner une des familles qu'il a créé
     **/
    ClientAccountsState.prototype.setSelectedFamily = function (familyId) {
        var _a;
        this.draftState.selectedClientFamily =
            ((_a = this.draftState.clientFamilies) === null || _a === void 0 ? void 0 : _a.find(function (family) { return family.familyId === familyId; })) || null;
        this.draftState.isFamilyMode = true;
    };
    ClientAccountsState.prototype.reset = function () {
        this.draftState = exports.initialState;
    };
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    ClientAccountsState.prototype.addContract = function (contractInformation) {
        this.draftState.addContractLoading = true;
        this.draftState.addContractErrorMsg = null;
        this.draftState.addContractSuccess = null;
    };
    ClientAccountsState.prototype.addContractFailure = function (errorMsg) {
        this.draftState.addContractLoading = false;
        this.draftState.addContractErrorMsg = errorMsg;
        this.draftState.addContractSuccess = false;
    };
    ClientAccountsState.prototype.addContractSuccess = function () {
        this.draftState.addContractLoading = false;
        this.draftState.addContractErrorMsg = null;
        this.draftState.addContractSuccess = true;
    };
    ClientAccountsState.prototype.resetAddContract = function () {
        this.draftState.addContractLoading = exports.initialState.addContractLoading;
        this.draftState.addContractErrorMsg = exports.initialState.addContractErrorMsg;
        this.draftState.addContractSuccess = exports.initialState.addContractSuccess;
    };
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    ClientAccountsState.prototype.addContractV2 = function (contractInformation) {
        this.draftState.addContractLoading = true;
        this.draftState.addContractErrorMsg = null;
        this.draftState.addContractSuccess = null;
    };
    ClientAccountsState.prototype.addContractV2Failure = function (errorMsg) {
        this.draftState.addContractLoading = false;
        this.draftState.addContractErrorMsg = errorMsg;
        this.draftState.addContractSuccess = false;
    };
    ClientAccountsState.prototype.addContractV2Success = function () {
        this.draftState.addContractLoading = false;
        this.draftState.addContractErrorMsg = null;
        this.draftState.addContractSuccess = true;
    };
    ClientAccountsState.prototype.resetAddContractV2 = function () {
        this.draftState.addContractLoading = exports.initialState.addContractLoading;
        this.draftState.addContractErrorMsg = exports.initialState.addContractErrorMsg;
        this.draftState.addContractSuccess = exports.initialState.addContractSuccess;
    };
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    ClientAccountsState.prototype.updateContractName = function (payload) {
        this.draftState.updateContractName.loading = true;
    };
    ClientAccountsState.prototype.updateContractNameFailure = function (errorMsg) {
        this.draftState.updateContractName.loading = false;
        this.draftState.updateContractName.errorMessage = errorMsg;
        this.draftState.updateContractName.success = false;
        this.draftState.updateContractName.status = 'failure';
    };
    ClientAccountsState.prototype.updateContractNameSuccess = function () {
        this.draftState.updateContractName.loading = false;
        this.draftState.updateContractName.errorMessage = null;
        this.draftState.updateContractName.success = true;
        this.draftState.updateContractName.status = 'success';
    };
    ClientAccountsState.prototype.updateSelectedContract = function () {
        if (this.draftState.selectedClientAccount) {
            this.setSelectedClientAccount(this.draftState.selectedClientAccount.clientId);
        }
        if (this.draftState.selectedCustomerAccount) {
            this.setSelectedCustomerAccount(this.draftState.selectedCustomerAccount.customerAccountId);
        }
        if (this.draftState.selectedSectionSubscripiton) {
            this.setSelectedSectionSubscription(this.draftState.selectedSectionSubscripiton
                .sectionSubscriptionId);
        }
    };
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    ClientAccountsState.prototype.removeContract = function (clientAccountToRemove) {
        this.draftState.removeContract.removeContractLoading = true;
        this.draftState.removeContract.removeContractErrorMsg = null;
        this.draftState.removeContract.removeContractSuccess = null;
    };
    ClientAccountsState.prototype.removeContractFailure = function (errorMsg) {
        this.draftState.removeContract.removeContractLoading = false;
        this.draftState.removeContract.removeContractErrorMsg = errorMsg;
        this.draftState.removeContract.removeContractSuccess = false;
        this.draftState.removeContract.removeContractStatus = 'failure';
    };
    ClientAccountsState.prototype.removeContractSuccess = function (clientAccountToRemove) {
        var _a, _b, _c;
        var sectionsSubscriptionsList = clientAccountToRemove.customerAccounts.flatMap(function (customAccnt) {
            return customAccnt.sectionSubscriptions
                .filter(function (s) { return !s.isContractTerminated; })
                .map(function (sectionSub) { return sectionSub.sectionSubscriptionId; });
        });
        //Remove client Account from state
        this.draftState.clientAccounts =
            ((_a = this.draftState.clientAccounts) === null || _a === void 0 ? void 0 : _a.filter(function (clientAccount) {
                return clientAccount.clientId !== clientAccountToRemove.clientId;
            })) || [];
        // clean up families
        (_b = this.draftState.clientFamilies) === null || _b === void 0 ? void 0 : _b.forEach(function (family) {
            family.sectionSubscriptions = family.sectionSubscriptions.filter(function (sectionSub) {
                return !sectionsSubscriptionsList.includes(sectionSub.sectionSubscriptionId);
            });
        });
        this.draftState.clientFamilies =
            ((_c = this.draftState.clientFamilies) === null || _c === void 0 ? void 0 : _c.filter(function (family) { return family.sectionSubscriptions.length > 0; })) || [];
        this.draftState.removeContract.removeContractLoading = false;
        this.draftState.removeContract.removeContractErrorMsg = null;
        this.draftState.removeContract.removeContractSuccess = true;
        this.draftState.removeContract.removeContractStatus = 'success';
    };
    ClientAccountsState.prototype.resetremoveContract = function () {
        this.draftState.removeContract.removeContractLoading =
            exports.initialState.removeContract.removeContractLoading;
        this.draftState.removeContract.removeContractErrorMsg =
            exports.initialState.removeContract.removeContractErrorMsg;
        this.draftState.removeContract.removeContractSuccess =
            exports.initialState.removeContract.removeContractSuccess;
        this.draftState.removeContract.removeContractStatus =
            exports.initialState.removeContract.removeContractStatus;
    };
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    ClientAccountsState.prototype.deleteFamily = function (familyId) {
        this.draftState.deleteFamily.loading = true;
        this.draftState.deleteFamily.errorMessage = null;
        this.draftState.deleteFamily.success = null;
    };
    ClientAccountsState.prototype.deleteFamilySuccess = function (familyId) {
        var _a;
        this.draftState.clientFamilies =
            ((_a = this.draftState.clientFamilies) === null || _a === void 0 ? void 0 : _a.filter(function (family) { return family.familyId !== familyId; })) || [];
        this.draftState.deleteFamily.loading = false;
        this.draftState.deleteFamily.errorMessage = null;
        this.draftState.deleteFamily.success = true;
    };
    ClientAccountsState.prototype.deleteFamilyFailure = function (errorMsg) {
        this.draftState.deleteFamily.loading = false;
        this.draftState.deleteFamily.errorMessage = errorMsg;
        this.draftState.deleteFamily.success = false;
    };
    ClientAccountsState.prototype.resetDeleteFamilyState = function () {
        this.draftState.deleteFamily.loading = false;
        this.draftState.deleteFamily.errorMessage = null;
        this.draftState.deleteFamily.success = null;
    };
    ClientAccountsState.prototype.resetUpdateContractNameResult = function () {
        this.draftState.updateContractName.status = 'none';
    };
    // Create family
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    ClientAccountsState.prototype.createFamily = function (createFamilPayload) {
        this.draftState.createFamily.loading = true;
        this.draftState.createFamily.errorMessage = null;
        this.draftState.createFamily.success = null;
    };
    ClientAccountsState.prototype.createFamilyFailure = function (errorMsg) {
        this.draftState.createFamily.loading = false;
        this.draftState.createFamily.errorMessage = errorMsg;
        this.draftState.createFamily.success = false;
    };
    ClientAccountsState.prototype.createFamilySuccess = function (createdFamily) {
        this.draftState.clientFamilies = __spreadArray(__spreadArray([], (this.draftState.clientFamilies || []), true), [
            createdFamily
        ], false);
        this.draftState.createFamily.loading = false;
        this.draftState.createFamily.errorMessage = null;
        this.draftState.createFamily.success = true;
    };
    ClientAccountsState.prototype.resetCreateFamily = function () {
        this.draftState.createFamily.loading =
            exports.initialState.createFamily.loading;
        this.draftState.createFamily.errorMessage =
            exports.initialState.createFamily.errorMessage;
        this.draftState.createFamily.success =
            exports.initialState.createFamily.success;
    };
    // Update family
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    ClientAccountsState.prototype.updateFamily = function (updateFamilyPayload) {
        this.draftState.updateFamily.loading = true;
        this.draftState.updateFamily.errorMessage = null;
        this.draftState.updateFamily.success = null;
    };
    ClientAccountsState.prototype.updateFamilyFailure = function (errorMsg) {
        this.draftState.updateFamily.loading = false;
        this.draftState.updateFamily.errorMessage = errorMsg;
        this.draftState.updateFamily.success = false;
    };
    ClientAccountsState.prototype.updateFamilySuccess = function (familyPayload) {
        var _this = this;
        var _a;
        var updatedFamily = new ClientFamily_1.default(familyPayload.family);
        this.draftState.clientFamilies =
            ((_a = this.draftState.clientFamilies) === null || _a === void 0 ? void 0 : _a.map(function (family) {
                if (family.familyId === updatedFamily.familyId) {
                    _this.draftState.selectedClientFamily = updatedFamily;
                    return updatedFamily;
                }
                return family;
            })) || [];
        this.draftState.updateFamily.loading = false;
        this.draftState.updateFamily.errorMessage = null;
        this.draftState.updateFamily.success = true;
    };
    ClientAccountsState.prototype.resetUpdateFamily = function () {
        this.draftState.updateFamily.loading =
            exports.initialState.updateFamily.loading;
        this.draftState.updateFamily.errorMessage =
            exports.initialState.updateFamily.errorMessage;
        this.draftState.updateFamily.success =
            exports.initialState.updateFamily.success;
    };
    // rename Section Subscription
    ClientAccountsState.prototype.renameSectionSubscription = function (
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    sectionSubscription) {
        this.draftState.renameSectionSubscription.loading = true;
        this.draftState.renameSectionSubscription.errorMessage = null;
        this.draftState.renameSectionSubscription.success = null;
    };
    ClientAccountsState.prototype.renameSectionSubscriptionFailure = function (errorMsg) {
        this.draftState.renameSectionSubscription.loading = false;
        this.draftState.renameSectionSubscription.errorMessage = errorMsg;
        this.draftState.renameSectionSubscription.success = false;
    };
    ClientAccountsState.prototype.renameSectionSubscriptionSuccess = function (renameSectionSubscriptionPayload) {
        var _a, _b, _c;
        var newCustomerAccount = (_a = this.draftState.clientAccounts) === null || _a === void 0 ? void 0 : _a.flatMap(function (c) { return c.customerAccounts; }).find(function (d) {
            return d.sectionSubscriptions.find(function (s) {
                return s.sectionSubscriptionId ===
                    renameSectionSubscriptionPayload.sectionSubscriptionId;
            });
        });
        var newClientAccount = (_b = this.draftState.clientAccounts) === null || _b === void 0 ? void 0 : _b.find(function (cliAccnt) {
            return cliAccnt.customerAccounts.find(function (custAccnt) {
                return custAccnt.sectionSubscriptions.find(function (sub) {
                    return sub.sectionSubscriptionId ===
                        renameSectionSubscriptionPayload.sectionSubscriptionId;
                });
            });
        });
        if (newClientAccount && newCustomerAccount) {
            newCustomerAccount = __assign(__assign({}, newCustomerAccount), { sectionSubscriptions: newCustomerAccount.sectionSubscriptions.map(function (s) {
                    return s.sectionSubscriptionId ===
                        renameSectionSubscriptionPayload.sectionSubscriptionId
                        ? __assign(__assign({}, s), { name: renameSectionSubscriptionPayload.sectionSubscriptionName }) : s;
                }) });
            newClientAccount = __assign(__assign({}, newClientAccount), { customerAccounts: newClientAccount.customerAccounts.map(function (c) {
                    return c.customerAccountId ===
                        (newCustomerAccount === null || newCustomerAccount === void 0 ? void 0 : newCustomerAccount.customerAccountId)
                        ? newCustomerAccount
                        : c;
                }) });
            this.draftState.clientAccounts =
                ((_c = this.draftState.clientAccounts) === null || _c === void 0 ? void 0 : _c.map(function (c) {
                    return c.clientId === (newClientAccount === null || newClientAccount === void 0 ? void 0 : newClientAccount.clientId)
                        ? newClientAccount
                        : c;
                })) || null;
        }
        this.draftState.renameSectionSubscription.loading = false;
        this.draftState.renameSectionSubscription.errorMessage = null;
        this.draftState.renameSectionSubscription.success = true;
    };
    ClientAccountsState.prototype.resetRenameSectionSubscription = function () {
        this.draftState.renameSectionSubscription.loading =
            exports.initialState.updateFamily.loading;
        this.draftState.renameSectionSubscription.errorMessage =
            exports.initialState.updateFamily.errorMessage;
        this.draftState.renameSectionSubscription.success =
            exports.initialState.updateFamily.success;
    };
    ClientAccountsState.prototype.getEligibilityCoachConso = function (customerAccountId, locale) {
        if (locale === void 0) { locale = 'en'; }
        this.draftState.eligibilityCoachConso.loading = true;
        this.draftState.eligibilityCoachConso.errorMessage = null;
        this.draftState.eligibilityCoachConso.success = false;
        this.draftState.eligibilityCoachConso.data = null;
    };
    ClientAccountsState.prototype.getEligibilityCoachConsoSuccess = function (apiResponse) {
        this.draftState.eligibilityCoachConso.loading = false;
        this.draftState.eligibilityCoachConso.errorMessage = null;
        this.draftState.eligibilityCoachConso.success = true; // OK 200
        this.draftState.eligibilityCoachConso.data = apiResponse;
    };
    ClientAccountsState.prototype.getEligibilityCoachConsoFailure = function (errorMsg, apiResponse) {
        this.draftState.eligibilityCoachConso.loading = false;
        this.draftState.eligibilityCoachConso.errorMessage = errorMsg;
        this.draftState.eligibilityCoachConso.success = false; // not OK 200
        this.draftState.eligibilityCoachConso.data = apiResponse;
    };
    return ClientAccountsState;
}(immer_reducer_1.ImmerReducer));
exports.ClientAccountsState = ClientAccountsState;
exports.clientAccountsActions = (0, immer_reducer_1.createActionCreators)(ClientAccountsState);
exports.clientAccountsReducerFunction = (0, immer_reducer_1.createReducerFunction)(ClientAccountsState, exports.initialState);
